var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3237 12.9258H8.32373C7.91373 12.9258 7.57373 12.5858 7.57373 12.1758C7.57373 11.7658 7.91373 11.4258 8.32373 11.4258H16.3237C16.7337 11.4258 17.0737 11.7658 17.0737 12.1758C17.0737 12.5858 16.7337 12.9258 16.3237 12.9258Z",
    fill: "#737373"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3237 16.9258C11.9137 16.9258 11.5737 16.5858 11.5737 16.1758V8.17578C11.5737 7.76578 11.9137 7.42578 12.3237 7.42578C12.7337 7.42578 13.0737 7.76578 13.0737 8.17578V16.1758C13.0737 16.5858 12.7337 16.9258 12.3237 16.9258Z",
    fill: "#737373"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3237 22.9258H9.32373C3.89373 22.9258 1.57373 20.6058 1.57373 15.1758V9.17578C1.57373 3.74578 3.89373 1.42578 9.32373 1.42578H15.3237C20.7537 1.42578 23.0737 3.74578 23.0737 9.17578V15.1758C23.0737 20.6058 20.7537 22.9258 15.3237 22.9258ZM9.32373 2.92578C4.71373 2.92578 3.07373 4.56578 3.07373 9.17578V15.1758C3.07373 19.7858 4.71373 21.4258 9.32373 21.4258H15.3237C19.9337 21.4258 21.5737 19.7858 21.5737 15.1758V9.17578C21.5737 4.56578 19.9337 2.92578 15.3237 2.92578H9.32373Z",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.2b511e5b60e5bea734cff442fc15eaa6.svg";
export { ForwardRef as ReactComponent };